import { isArray } from "lodash-es";

import type { FormDocument } from "@/components/DocumentInput/useDocumentInput";
import type { FormImage } from "@/components/ImageInput/useImageInput";
import type { FormVideo } from "@/components/VideoInput/useVideoInput";
import type { TranslationFunction } from "@/translations";

export const MAXIMUM_IMAGE_FILE_SIZE_IN_MEGA_BYTES = 28;
export const MAXIMUM_DOCUMENT_FILE_SIZE_IN_MEGA_BYTES = 28;
export const MAXIMUM_VIDEO_FILE_SIZE_IN_MEGA_BYTES = 512;

export function megaBytesToBytes(sizeInMegaBytes: number): number {
  return sizeInMegaBytes * 1024 * 1024;
}

export function validateSize(
  t: TranslationFunction,
  upload: FormImage | FormImage[] | FormDocument | FormDocument[] | FormVideo | FormVideo[],
  maximumSizeInMegaBytes: number,
): string | undefined {
  if (!upload) {
    return;
  }

  let isTooBig = false;
  if (isArray(upload)) {
    for (const uploadFile of upload) {
      if (isFileTooBig(uploadFile, maximumSizeInMegaBytes)) {
        isTooBig = true;
        break;
      }
    }
  } else if (isFileTooBig(upload, maximumSizeInMegaBytes)) {
    isTooBig = true;
  }

  if (isTooBig) {
    return t("components.form.error.file-too-big", {
      sizeInMegaBytes: maximumSizeInMegaBytes,
    });
  }
}

export function isFileTooBig(upload: FormImage | FormDocument | FormVideo, maximumSizeInMegaBytes: number): boolean {
  if ("file" in upload && upload.file.size > megaBytesToBytes(maximumSizeInMegaBytes)) {
    return true;
  }

  return false;
}

export function formatFileSize(bytes: number, fractionDigits = 0): string {
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];

  if (bytes === 0) {
    return "0 Byte";
  }

  const i = Math.floor(Math.log(bytes) / Math.log(1024));

  if (i === 0) {
    return `${bytes} ${sizes[i]}`;
  }

  return `${(bytes / Math.pow(1024, i)).toFixed(fractionDigits)} ${sizes[i]}`;
}
